import {
    COURSE_TYPES,
    HELPER_TYPES,
    MEDIA_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../types";

const state = {
    isSidebarActive: true,
    loadingIds: [],
    errorIds: {},
    toastMessage: null,
};
const getters = {
    [HELPER_TYPES.GET_IS_SIDEBAR_ACTIVE]: (state) => state.isSidebarActive,
    [HELPER_TYPES.GET_LOADING_IDS]: (state) => state.loadingIds,
    [HELPER_TYPES.GET_ERROR_IDS]: (state) => state.errorIds,
    [HELPER_TYPES.GET_TOAST_MESSAGE]: (state) => state.toastMessage,
};
const actions = {
    async [HELPER_TYPES.RESET_DATA]({ commit }) {
        commit(`${STORE_TYPES.MEDIA}/${MEDIA_TYPES.SET_MATERIALS}`, [], {
            root: true,
        });
        commit(`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`, null, {
            root: true,
        });
        commit(`${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_COURSES}`, [], {
            root: true,
        });
        commit(
            `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_COURSE}`,
            {},
            {
                root: true,
            }
        );
        commit(
            `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SHOW_DOCUMENTS}`,
            false,
            {
                root: true,
            }
        );
    },
};
const mutations = {
    [HELPER_TYPES.SET_IS_SIDEBAR_ACTIVE]: (state, value) =>
        (state.isSidebarActive = value),

    [HELPER_TYPES.SET_LOADING_IDS]: (state, array) =>
        (state.loadingIds = array),
    [HELPER_TYPES.SET_LOADING_ID]: (state, string) =>
        state.loadingIds.push(string),
    [HELPER_TYPES.REMOVE_LOADING_ID]: (state, string) =>
        (state.loadingIds = state.loadingIds.filter(
            (loadingId) => loadingId != string
        )),
    [HELPER_TYPES.SET_ERROR_IDS]: (state, object) => (state.errorIds = object),
    [HELPER_TYPES.SET_ERROR_ID_OBJECT]: (state, object) =>
        (state.errorIds = Object.assign(state.errorIds, object)),
    [HELPER_TYPES.REMOVE_ERROR_ID]: (state, string) =>
        (state.errorIds[string] = null),
    [HELPER_TYPES.SET_TOAST_MESSAGE]: (state, string) =>
        (state.toastMessage = string),
};

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
};
